

import MovieApi from "../../api/movies";
import CountriesApi from "../../api/countries";

const state = {
  country: '',
  searchData:'',
  availableCountry: {},
  selectedMovie:{},
  movies: {},
  movielist: {},
  requestmovies:{},
  loading: false,
};

const getters = {

  allmovies: state => {
    return state.movielist;
  },

  movielist: state => {

    return state.movies;
  },
  currentPage : state => {

    return state.requestmovies.current_page
  },
  lastPage : state => {

    return state.requestmovies.last_page
  }, 

  selectedCountry: state => {

    return state.country;
  },
  availableCountry: state => {
    
    return state.availableCountry;
  },
  selectedMovie: state => {

    return state.selectedMovie;
  },
  
};

const actions = {
 
  async GetMovies({ commit }) {
    commit('SET_LOADING', true);

    await MovieApi.list({
      country: state.country,
    })
      .then(
        response => {

          commit("SET_MOVIES",response.data);

        });  

      commit('SET_LOADING', false); 
  },
  async searchMovie({ commit },payload) {

    commit('SET_LOADING', true);
    
    await MovieApi.all({
      country: state.country,
      searchData: state.searchData,
      page: payload.page,
      limit: payload.limit
    })
        .then(
          response => {
            commit("SET_REQUESTMOVIES",response.data);
            commit("SET_MOVIELIST",response.data.data);
          }
        );

      commit('SET_LOADING', false); 
  },
   loadLocation({ commit }, payload) {


    // CountriesApi.search(payload)
    // .then(
    //    response => {   
           
    //       commit("SET_COUNTRY",response.data['0'].name.common );
    //    });

    // console.log( payload );

    commit("SET_COUNTRY",payload );
   
  },
   loadCountries({ commit}, payload ) {

    CountriesApi.availableCountry()
      .then(
        response => {

          commit("SET_COUNTRIES",response.data);
        }
      )
  },
  loadSelectedMovie({ commit }, payload ) {

      commit("SET_SELECTED_MOVIE",payload);
  },
  loadSearchData({ commit }, payload){

    commit("SET_SEARCHDATA",payload);
  },
  async pushMovies( {commit}, payload){

      let list = state.movielist;

      commit('SET_LOADING', true);
    
    await MovieApi.all({
      country: state.country,
      searchData: state.searchData,
      page: payload.page,
      limit: payload.limit
    })
        .then(
          response => {

            commit("SET_REQUESTMOVIES",response.data);

            response.data.data.forEach((item) =>{

                list.push(item);
            });

            commit("SET_MOVIELIST",list);
          }
        );

      commit('SET_LOADING', false); 


  }
  
};

const mutations = {
  
  SET_MOVIES: (state, data) => state.movies = data,
  SET_COUNTRY: (state, data) => state.country = data,
  SET_COUNTRIES: (state, data) => state.availableCountry = data,
  SET_LOADING: (state, data) => state.loading = data,
  SET_SELECTED_MOVIE: (state,data ) => state.selectedMovie = data,
  SET_MOVIELIST: (state,data) => state.movielist = data,
  SET_SEARCHDATA: (state,data) => state.searchData = data,
  SET_REQUESTMOVIES: (state,data) => state.requestmovies = data,

};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
